import React from 'react';

import { CorporateSubscriberCirclePartner } from '../../utils/backend-api/partners';
import { Button } from '../BaseUI';

interface CorporateSubscriberCircleCardProps {
  partner: CorporateSubscriberCirclePartner;
}

const CorporateSubscriberCircleCard = ({ partner }: CorporateSubscriberCircleCardProps) => {
  const { id, name, tagline, targetLink } = partner;
  return (
    <div className="tw-text-grey-80 tw-text-[14px] tw-font-['Meta',Georgia,sans-serif] tw-pl-12 tw-py-3 tw-mb-8 tw-border-0 tw-border-l tw-border-[#c4c6ce] tw-border-solid">
      <Button
        href={targetLink}
        variant="link"
        trackClick
        trackingProps={{
          name: 'csc_card',
          identifier: id.toString(),
        }}
      >
        {name}: {tagline}
      </Button>
    </div>
  );
};

export default CorporateSubscriberCircleCard;
